import React, {useState} from 'react';

import NumericInput from 'ui-library/inputs/NumericInput';
import SetAllDropdownWrapper from 'ui-library/SetAllDropdownWrapper';
import {NumericInputChangeEvent} from 'util/Types';

interface BulkSetValuesDropdownProps {
  onSetValue: (value: number | null) => void;
}

export default function BulkSetValuesDropdown(props: BulkSetValuesDropdownProps): JSX.Element {
  const [inputValue, setInputValue] = useState<number | null>(null);
  const [isValid, setIsValid] = useState(true);

  const handleChangeInput = (e: NumericInputChangeEvent): void => {
    setInputValue(e.target.numericValue);
    setIsValid(e.target.isValid);
  };

  const handleSetValue = (): void => {
    props.onSetValue(inputValue);
  };

  return (
    <SetAllDropdownWrapper isDisabled={!isValid} onSetAll={handleSetValue}>
      <NumericInput focusOnMount={true} onChange={handleChangeInput} value={inputValue} />
    </SetAllDropdownWrapper>
  );
}
